// custom axios to user token and refresh token
import axios from "axios";
import store from "../redux/store";

import { API_ENDPOINT } from "../utils/constants";
import { setTokens, logout } from "../redux/slices/authSlice"; // import logout

const api = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    // gets token  from redux store
    const st = store.getState();
    if(!st.authReducer) {
      console.error("authReducer not found in store");
      return config;
    }
    const token = st.authReducer.token;
    console.log("token", token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 402 && !originalRequest?._retry) {
      originalRequest._retry = true;
      const st = store.getState();
      const refreshToken = st.authReducer.refreshToken;
      if (!refreshToken) {
        store.dispatch(logout());
        return Promise.reject(error);
      }
      try {
        const res = await axios.post(`${API_ENDPOINT}/auth/refresh-token`, {
          token: refreshToken,
        });
        if (res.status === 200) {
          const { token: newToken, refreshToken: newRefreshToken } = res.data;
          let payload = {
            token: newToken,
            refreshToken: newRefreshToken,
          };
          localStorage.setItem("token", newToken);
          localStorage.setItem("refreshToken", newRefreshToken);
          store.dispatch(setTokens(payload));
          // redirect
          window.location.href = '/'
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        }
      } catch (refreshError) {
        // If refresh fails (e.g., 401/403), logout
        store.dispatch(logout());
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
